import React from 'react';
import { View, TouchableOpacity, ActionSheetIOS, Dimensions, Modal, Text, Image, ScrollView, ActivityIndicator, Platform } from 'react-native';
import PhotoPreview from './PhotoPreview';
import FilePreview from './FilePreview';
import { containerDimensions, getImageFieldsForUpload, dataUrlToFile, isImageExtensionValid } from '../../utils/Functions';
import Alert from '../../components/Alert'; // leave as is or else you get a require cycle warning
import Button from '../../components/Button'; // leave as is or else you get a require cycle warning
import TextInputContainer from '../../components/TextInputContainer'; // leave as is or else you get a require cycle warning
import * as rtApi from '../../components/Api';
import { FontAwesome, FontAwesome5, AntDesign, Entypo } from '@expo/vector-icons';
import styles from './styles';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import Images from '../../constants/Images';
import * as ImagePicker from 'expo-image-picker';
import { Camera } from 'expo-camera';
import * as DocumentPicker from 'expo-document-picker';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { FlingGestureHandler, Directions, State } from 'react-native-gesture-handler';
import UserState from '../../src/contexts/UserState';
import CachedImage from '../../components/CachedImage';
import Storage from '../../components/Storage';
import PDFReader from 'rn-pdf-reader-js';
import { Portal } from 'react-native-paper';

export const PhotosDocumentsAddPreviewGrid = (props) => {
  const [user, setUser] = React.useContext(UserState);
  const [alertOptions, setAlertOptions] = React.useState({});

  const [horizontalCount, setHorizontalCount] = React.useState(4);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [caption, setCaption] = React.useState(''); // for new caption
  const [captionImgResult, setCaptionImgResult] = React.useState(null);
  const [saveOrEdit, setSaveOrEdit] = React.useState('save');

  const [previewDocumentModalVisible, setPreviewDocumentModalVisible] = React.useState(false);
  const [documentModalVisible, setDocumentModalVisible] = React.useState(false);
  const [fileName, setFileName] = React.useState('');
  const [fileExtension, setFileExtension] = React.useState('');
  const [documentResult, setDocumentResult] = React.useState(null);
  // const [documentModalIndex, setDocumentImageIndex] = React.useState(null);
  const [editingExistingFileName, setEditingExistingFileName] = React.useState(false);

  const [itemPreviewModalVisible, setItemPreviewModalVisible] = React.useState(false);
  // const [imageModal, setImageModal] = React.useState(false);
  // const [imageModalIndex, setImageModalIndex] = React.useState(null);
  const [previewItemIndex, setPreviewItemIndex] = React.useState(null);
  const [editingCaption, setEditingCaption] = React.useState(false);
  const [existingCaption, setExistingCaption] = React.useState(''); //used to store old caption when editing
  const [imageModalLoading, setImageModalLoading] = React.useState(false);

  const performUpload = (props.upload === undefined || props.upload === false) ? false : true;
  const showAdd = props.editing || true;
  const showDelete = ((props.delete === undefined || props.delete === true) && props.showAdd) ? true : false;
  const isScrollable = (props.scrollable === undefined || props.scrollable === false) ? false : true;
  const requiresApproval = (props.requiresApproval === undefined || props.requiresApproval === false) ? false : true;

  const showDocuments = props.documents || false;

  const insets = useSafeAreaInsets();
  const height = Dimensions.get('window').height;

  const [previewImageStyle, setPreviewImageStyle] = React.useState({});

  const [captionOverlayHeight, setCaptionOverlayHeight] = React.useState(0);
  const [containerStyle, setContainerStyle] = React.useState(containerDimensions(horizontalCount, props.items.length));
  

  // const Loader = require('../../assets/img/loader2.gif');
  // const Loader = require('../../assets/img/loader.png');
  // const Loader = require('../../assets/img/loader.jpg');

  React.useEffect(() => {
    const subscription = Dimensions.addEventListener('change', onChangeDimensions);
    return() => {
      subscription.remove();
      // Dimensions.removeEventListener('change', onChangeDimensions);
    }
  }, []);
  // let headers = {};
  const [headers, setHeaders] = React.useState({});
  const [rtJWT, setRtJWT] = React.useState('');
  React.useEffect(() => {
    (async () => {
      const rtJWT = await Storage.getItem('rtJWT');
      setRtJWT(rtJWT);
      setHeaders({ 'Authorization': `Bearer ${rtJWT}` });
    })()
  }, []);

  React.useEffect(() => {
    console.log('useFfect test', itemPreviewModalVisible);
    if (itemPreviewModalVisible && props.items[previewItemIndex].type === 'image'){
      let style = {};
      if (Platform.OS === 'web') {
        const ratio1 = props.items[previewItemIndex].existing ? Images.project.main.height / Images.project.main.width : props.items[previewItemIndex].height / props.items[previewItemIndex].width;
        const width = Dimensions.get('window').width;
        style = {
          width: width,
          height: width * ratio1,
        };
      }else{
        const ratio2 = props.items[previewItemIndex].existing ? Images.project.main.width / Images.project.main.height : props.items[previewItemIndex].width / props.items[previewItemIndex].height;
        style = {
          aspectRatio: ratio2
        };
      }
      setPreviewImageStyle(style);
    }
  }, [itemPreviewModalVisible]);

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions: ', window.width, screen);
    if(window.width >= 501){
      setHorizontalCount(4)
    }else if(window.width <= 500){
      setHorizontalCount(2);
    }
    setContainerStyle(containerDimensions(horizontalCount, props.items.length));
    // if(window.width <= 500){
    //   setHorizontalCount(4);
    // }else if(window.width <= 720){
    //   setHorizontalCount(6);
    // }else{
    //   setHorizontalCount(8);
    // }
  }
  // add an item, take photo, choose photo, add pdf document
  const addItem = () => {
    if(Platform.OS === 'ios'){
      let options = ['Cancel', 'Take Photo', 'Choose Existing Photo'];
      if (showDocuments) { options.push('Choose PDF File'); }
      ActionSheetIOS.showActionSheetWithOptions(
        {
          options: options,
          cancelButtonIndex: 0,
        },
        buttonIndex => {
          if (buttonIndex === 0) {
            // cancel action
          } else if (buttonIndex === 1) {
            takePhoto();
          } else if (buttonIndex === 2) {
            choosePhoto();
          } else if (buttonIndex === 3) {
            chooseDocument();
          }
        }
      );
    }else if(Platform.OS === 'android'){
      let alertButtons = [
        {
          text: 'Take Photo',
          onPress: () => takePhoto(),
        },
        {
          text: 'Choose Photo',
          onPress: () => choosePhoto(),
        },
        {
          text: 'Cancel',
          onPress: () => null,
        }
      ]
      if(showDocuments) {
        alertButtons.push({
          text: 'Choose Document',
          onPress: () => chooseDocument(),
        });
      }
      setAlertOptions({
        visible: true,
        // title: 'Choose an option',
        message: 'Choose an action to perform',
        buttons: alertButtons,
        dismissable: true,
      });
    }else{
      //web
      console.log('on web ...')
      // choosePhoto();
      
      if (showDocuments) {
        setAlertOptions({
          visible: true,
          // title: 'Choose an option',
          message: 'Choose an action to perform',
          dismissable: true,
          buttons: [
            {
              text: 'Choose Photo',
              onPress: () => choosePhoto(),
            },
            {
              text: 'Choose Document',
              onPress: () => chooseDocument(),
            },
            {
              text: 'Cancel',
              onPress: () => null,
            }
          ],
        });
      }else{
        choosePhoto();
      }
    }
    
  }
  const choosePhoto = async () => {
    // if (Platform.OS !== 'web') {
      const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
    console.log('ImagePicker.requestMediaLibraryPermissionsAsync status: ', status, ImagePicker.MediaTypeOptions.Images);
      if (status !== 'granted') {
        Alert('warning', 'Sorry, we need camera roll permissions to make this work!');
      } else {
        let result = await ImagePicker.launchImageLibraryAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          allowsEditing: true,
          aspect: [1, 1],
          quality: Images.quality,
        });
        if (!result.canceled) {
          console.log(result);
          if(Platform.OS === 'web'){
            result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
          }
          const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
          if (!isValidExtension.result){
            setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
            return;
          }
          result.assets[0].type = 'image';
          result.assets[0].user = getUserFullName();
          result.assets[0].date = getFullDate();
          console.log(result);
          handleResult(result.assets[0]);
        }
      }
    // }
  }
  const takePhoto = async () => {
    if (Platform.OS !== 'web') {
      // const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      const { status } = await Camera.requestCameraPermissionsAsync();
      console.log('Camera.requestCameraPermissionsAsync status: ', status);
      if (status !== 'granted') {
        Alert('warning', 'Sorry, we need camera roll permissions to make this work!');
      } else {
        let result = await ImagePicker.launchCameraAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          allowsEditing: true,
          aspect: [1, 1],
          quality: Images.quality,
        });
        result.assets[0].type = 'image';
        result.assets[0].user = getUserFullName();
        result.assets[0].date = getFullDate();

        console.log(result);

        if (!result.canceled) {
          handleResult(result.assets[0]);
        }
      }
    }
  }
  // delete uploaded item
  const deleteItem = (item) => {
    console.log('deleteItem() ', item);
    console.log('delete url ', props.uploadDeleteUrl);
    
    return new Promise((resolve, reject) => {
      let url = props.uploadDeleteUrl;
      url = url.replace(':id', item.id);
      rtApi.remove(url)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        if(data.result){
          deleteLocalItem(item);
        }else{
          setAlertOptions({ visible: true, title: 'Error', message: 'Something went wrong, please try again.', });
        }
        resolve(data);
      }).catch(err => {
        reject(err);
      })
    });
  }
  // delete local item from items[]
  const deleteLocalItem = (item) => {
    //remove item from array
    props.setItems(prevState => {
      return prevState.filter(p => {
        // return p.uri !== item.uri;
        return item.id ? p.id !== item.id : p.uri !== item.uri;
      });
    });
  }
  // edit existing uploaded image caption
  const startEditingCaption = () => {
    if(!props.showAdd){ return; }
    if(props.items[previewItemIndex].type === 'image'){
      editExistingCaption();
    }else if(props.items[previewItemIndex].type === 'file'){
      editExistingFileName();
    }
  }
  const editExistingCaption = () => {
    setExistingCaption(props.items[previewItemIndex].caption);
    setEditingCaption(true);
  }
  // cancel editing 
  const cancelEditingCaption = () => {
    revertExistingCaption();
    setEditingCaption(false);
  }
  // revert to the saved caption if editing cancelled or update failed
  const revertExistingCaption = () => {
    props.setItems(prevState => {
      let photos = [...prevState];
      photos[previewItemIndex].caption = existingCaption;
      return photos;
    });
  }
  // change local items caption
  const changeCaption = (c) => {
    props.setItems(prevState => {
      let photos = [...props.items];
      photos[previewItemIndex].caption = c;
      return photos;
    });
  }
  // hit save on a new image just added
  const saveCaptionNew = async () => {
    let result = {
      ...captionImgResult,
      caption: caption,
    }
    set(result);
    setModalVisible(false);
    setCaption('');
    setCaptionImgResult(null);
    console.log('saveCaptionNew()');
  }
  // hit save on an existing image caption modal
  const updateCaption = async () => {
    let currentPhoto = props.items[previewItemIndex];
    console.log('updateCaption: ', currentPhoto);
    if (currentPhoto.type === 'image' && currentPhoto.existing && currentPhoto.caption === caption){
      console.log('Nothing changed, closing editing');
      setEditingCaption(false);
      return;
    }
    if(props.saveCaption){
      try{
        let saveResult = await saveCaption(currentPhoto.caption, currentPhoto.id);
        if (saveResult.result) {
          console.log('caption updated successfully');
          setEditingCaption(false);
        }else{
          setAlertOptions({ visible: true, title: 'Error', message: 'Something went wrong, please try again.', });
          throw 'Not saved: result->false';
        }
      }catch(err){
        console.log('Save caption catch: Something went wrong, please try again later', err);
        revertExistingCaption();
        setEditingCaption(false);
      }
    }

    console.log('updateCaption()');
  }
  // handle the result of taking a photo or choosing an image
  const handleResult = (result) => {
    setSaveOrEdit('save');
    if (props.captions) {
      setCaptionImgResult(result);
      setModalVisible(true);
    }else{
      set(result)
    }
  }
  //add the item to the local items[] and call upload if applicable
  const set = (result) => {
    console.log('set: ', result);
    console.log('set2: ', saveOrEdit);
    result.existing = false;
    result.uploading = performUpload ? true : false;
    console.log('set3: ', result);
    if(saveOrEdit === 'save'){
      props.setItems(prevState => {
        const p = [...prevState];
        p.push(result);
        return p;
      });
      if(performUpload){
        upload(result);
      }
    }else{
      props.setItems(prevState => {
        let p = [...prevState];
        console.log('edit', prevState, result);
        p.forEach(photo => {
          if(photo.uri === result.uri){
            if(photo.type === 'image'){
              photo.caption = result.caption;
            }else if(photo.type === 'file'){
              photo.user_file_name = result.user_file_name;
            }
          }
        });
        return p;
      });
    }
  }
  
  // const editCaption = (which) => {
  //   setSaveOrEdit('edit');
  //   let photo = props.items[which];
  //   setCaption(photo.caption);
  //   setCaptionImgResult(photo);
  //   setModalVisible(true);
  // }
  // show a pdf document
  // const showDocument = (index) => {
  //   console.log('showDocument() index', index);
  //   // setDocumentResult(file);
  //   setDocumentImageIndex(index);
  //   setItemPreviewModalVisible(true);
  // }
  // choose a document
  const chooseDocument = async () => {
    const result = await DocumentPicker.getDocumentAsync({ type: 'application/pdf'});
    console.log('chooseDocument()', result);
    if(result.type === 'success'){
      setSaveOrEdit('save');
      setDocumentResult(result);
      let fName = result.name.substr(0, result.name.lastIndexOf('.'));
      let fEx = result.name.substr(result.name.lastIndexOf('.'));
      setFileName(fName);
      setFileExtension(fEx);
      setDocumentModalVisible(true);
    }
  }
  // hit save on inital file name prompt
  const saveFileName = () => {
    let result = {
      ...documentResult,
      user_file_name: fileName + fileExtension,
      type: 'file',
    }
    console.log('saveFileName: ', result);
    setSaveOrEdit('save');
    set(result);
    setDocumentModalVisible(false);
    setFileName('');
    setFileExtension('');
    setDocumentResult(null);
  }
  // edit file name intial
  const editFileName = (which) => {
    setSaveOrEdit('edit');
    let file = props.items[which];
    let fName = '';
    let fEx = '';
    fName = file.user_file_name.substr(0, file.user_file_name.lastIndexOf('.'));
    fEx = file.user_file_name.substr(file.user_file_name.lastIndexOf('.'));
    
    setFileName(fName);
    setFileExtension(fEx);
    setDocumentResult(file);
    setDocumentModalVisible(true);
  }
  const editExistingFileName = () => {
    let file = props.items[previewItemIndex];
    let fName = '';
    let fEx = '';
    fName = file.caption.substr(0, file.caption.lastIndexOf('.'));
    fEx = file.caption.substr(file.caption.lastIndexOf('.'));

    setFileName(fName);
    // setExistingFileName(fName);
    setFileExtension(fEx);
    setEditingExistingFileName(true);
  }
  const cancelEditingExistingFileName = () => {
    setEditingExistingFileName(false);
    setFileName('');
    setFileExtension('');
  }
  const saveExistingFileName = async () => {
    if (props.items[previewItemIndex].type === 'file' && props.items[previewItemIndex].existing && props.items[previewItemIndex].caption === caption) {
      console.log('Nothing changed, closing editing');
      setEditingExistingFileName(false);
      setFileName('');
      setFileExtension('');
      return;
    }
    if (props.saveCaption) {
      try {
        let caption = fileName + fileExtension;
        let saveResult = await saveCaption(caption, props.items[previewItemIndex].id);
        if (saveResult.result) {
          console.log('file name updated successfully');
          props.items[previewItemIndex].caption = caption;
          cancelEditingExistingFileName();
        } else {
          setAlertOptions({ visible: true, title: 'Error', message: 'Something went wrong, please try again later.', });
          throw 'Not saved: result->false';
        }
      } catch (err) {
        console.log('Save caption (file name) catch: Something went wrong, please try again later', err);
        cancelEditingExistingFileName(false);
      }
    }
    console.log('saveExistingFileName()');
  }
  // const deleteFile = (file) => {
  //   if (props.setRemoveIds && file.existing && file.id) {
  //     props.setRemoveIds(prevState => [...prevState, file.id]);
  //   }
  //   props.setItems(prevState => {
  //     return prevState.filter(p => {
  //       return p.uri !== file.uri;
  //     });
  //   })
  // };
  const showItem = async (which) => {
    console.log('showItem()', which);
    console.log('props.items', props.items);
    const type = props.items[which].type;
    setPreviewItemIndex(which);
    setItemPreviewModalVisible(true);
  }
  // close image modal
  const closeImageModal = () => {
    setPreviewItemIndex(null);
    setModalVisible(false);
  }
  // close document modal
  const closeDocumentModal = () => {
    setDocumentModalVisible(false);
  }
  // close preview document modal
  const closePreviewDocumentModal = () => {
    setPreviewDocumentModalVisible(false);
    setDocumentResult(null);
  }
  // previous navigation for full screen images
  const isIndexViable = (index) => {
    console.log('isIndexViable: ', index)
    if(Platform.OS === 'web'){
      if(props.items[index].type !== 'file'){
        console.log('viableIndex: ', index)
        return index;
      }
      console.log('!viableIndex: ', null)
      return null;
    }
    console.log('viableIndex: ', index)
    return index;
  }
  const previousModalIndex = () => {
    console.log('previous()', previewItemIndex);
    // OLD
    let count = props.items.length;
    let current = previewItemIndex + 1;
    if(current === 1){
      setPreviewItemIndex(props.items.length - 1);
    }else{
      setPreviewItemIndex(prevIndex => prevIndex - 1);
    }

    //NEW - bypass pdfs on web
    // let index = null;
    // let indexToTest = null;
    // let count = props.items.length;
    // let current = previewItemIndex - 1;
    // if (current < 0) {
    //   indexToTest = count;
    // } else {
    //   indexToTest = current;
    // }
    // console.log('indexToTest: ', indexToTest);
    // while (index === null) {
    //   index = isIndexViable(indexToTest);
    //   if(indexToTest === 0){
    //     indexToTest = count - 1;
    //   }else{
    //     indexToTest--;
    //   }
    // }
    // console.log('index: ', index);
    // setPreviewItemIndex(index);
  }
  // next navigation for full screen images
  const nextModalIndex = () => {
    console.log('next()', previewItemIndex);
    // OLD
    let count = props.items.length;
    let current = previewItemIndex + 1;
    if(current === count){
      setPreviewItemIndex(0);
    }else{
      setPreviewItemIndex(prevIndex => prevIndex + 1);
    }

    //NEW - bypass pdfs on web
    // let index = null;
    // let indexToTest = null;
    // let count = props.items.length;
    // let current = previewItemIndex + 1;
    // if (current === count) {
    //   indexToTest = 0;
    // } else {
    //   indexToTest = current;
    // }
    // console.log('indexToTest: ', indexToTest);
    // while(index === null){
    //   index = isIndexViable(indexToTest);
    //   if(indexToTest + 1 > count){
    //     indexToTest = 0;
    //   }else{
    //     indexToTest++;
    //   }
    // }
    // console.log('index: ', index);
    // setPreviewItemIndex(index);
  }
  // place navigation carets in middle of screen
  const caretTop = () => {
    // console.log('caretTop()', height);
    return {
      // top: ((height - insets.top - insets.bottom) / 2) - 24,
      top: (height / 2) - 24,
    }
  }
  // upload item
  const upload = (item) => {
    console.log('upload: ', item);
    let fd = new FormData();
    if(Platform.OS !== 'web'){
      let imgDetails = getImageFieldsForUpload(item.uri);
      console.log('imgDetails: ', imgDetails);
      // return;
      fd.append('upload', {
        uri: item.uri,
        name: imgDetails.filename,
        type: imgDetails.type,
      });
    }else{
      console.log('fd.append(upload, item.file);');
      fd.append('upload', item.file);
    }
    
    fd.append('uri', item.uri);
    fd.append('caption', (item.type === 'image') ? item.caption: item.user_file_name);
    // additional data to upload for each photo/file
    console.log('props.uploadAdditionalData: ', props.uploadAdditionalData);
    if (props.uploadAdditionalData){
      for (const property in props.uploadAdditionalData){
        fd.append(property, (item.type !== 'file') ? props.uploadAdditionalData[property] : 'file');
      }
    }
    rtApi.post(props.uploadUrl, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('after upload .then data: ', data);
      if(!data.result){ throw `Something went wrong. Please try uploading your ${item.type} again.`; }
      props.setItems(prevState => {
        let photos = [...prevState];
        photos.forEach(p => {
          if (p.uri === data.uri) {
            p.caption = item.type === 'file' ? item.user_file_name : item.caption;
            p.date = data.date;
            p.existing = true;
            p.id = data.id;
            p.path = data.path;
            p.type = item.type;
            p.uploading = false;
            p.user = getUserFullName();
            delete p.cancelled;
            delete p.uri;
            delete p.width;
            delete p.height;
            delete p.name;
            delete p.size;
            delete p.user_file_name;
            console.log('found image after upload p:', p);
          }
        });
        console.log('found image after upload photos:', photos);
        return photos;
      });
    }).catch(err => {
      console.log('upload catch: ', err);
      setAlertOptions({ visible: true, title: 'Error', message: err, });
      deleteLocalItem(item);

    });
  }
  // api request to save caption
  const saveCaption = (caption, id) => {
    console.log('saving caption');
    console.log('caption: ', caption);
    console.log('id: ', id);
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append('caption', caption);
      let url = props.captionUrl;
      url = url.replace(':id', id);
      rtApi.put(url, fd)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('caption saved: ', caption, id);
        resolve(data);
      }).catch(err => {
        console.log('caption catch', err);
        reject(err);
      });
    });
  }
  // get users full name
  const getUserFullName = () => {
    return user.first_name ? `${user.first_name} ${user.last_name}` : '';
  }
  // get full date from js
  const getFullDate = () => {
    let d = new Date();
    return `${d.toDateString()} ${d.toTimeString()}`;
  }

  // OUTPUT FUNCTIONS
  // output the thumbnails for image or file
  const itemsOutput = () => {
    return (
      props.items.map((p, index) => {
        if (p.type === 'image') {
          return (
            <PhotoPreview
              photo={p}
              key={index}
              which={index}
              captions={props.captions}
              rowItems={horizontalCount}
              /* editCaption={editCaption} */
              showItem={showItem}
              showDelete={showDelete}
              deleteItem={deleteItem}
              deleteLocalItem={deleteLocalItem}
              isScrollable={isScrollable}
              setDisabled={props.setDisabled}
              pendingApprovalAlert={props.pendingApprovalAlert}
              requiresApproval={requiresApproval}
            />
          );
        } else if (p.type === 'file') {
          return (
            <FilePreview
              file={p}
              key={index}
              which={index}
              captions={props.captions}
              rowItems={horizontalCount}
              editFileName={editFileName}
              showDelete={showDelete}
              deleteItem={deleteItem}
              deleteLocalItem={deleteLocalItem}
              showItem={showItem}
              isScrollable={isScrollable}
              setDisabled={props.setDisabled}
              pendingApprovalAlert={props.pendingApprovalAlert}
              requiresApproval={requiresApproval}
            />
          );
        }
      })
    )
  }
  // intial modal for adding caption to image
  const newImageModal = () => {
    if (Platform.OS === 'web' && !modalVisible) {
      return null;
    }
    return (
      <Portal>
        <Modal
          animationType="fade"
          transparent={true}
          visible={modalVisible}
          style={Platform.OS === 'web' && CS.webModal}
          >
          <View style={styles.centeredView}>
            <View style={styles.modalView}>
              <TouchableOpacity activeOpacity={0.6} style={styles.captionModalClose} onPress={() => closeImageModal()}>
                <AntDesign name="closecircle" size={32} color={Colors.lightBlue2} />
                <AntDesign name="closecircleo" size={32} color={Colors.blue3} style={{ position: 'absolute' }} />
              </TouchableOpacity>
              <Text style={[CS.smallText, CS.lightText, { marginBottom: 15 }]}>Add a caption for this photo</Text>
              {captionImgResult && captionImgResult.uri &&
                <Image source={{ uri: captionImgResult.uri }} style={[styles.captionImg, newImageStyle()]} />
              }
              <TextInputContainer
                placeholder='Provide a caption for this image'
                // onChangeText={(t) => changeCaption(t)}
                onChangeText={(t) => setCaption(t)}
                returnKeyType='done'
                onSubmitEditing={() => saveCaptionNew}
                value={caption}
                // style={styles.caption}
                autoCorrect={false}
                spellCheck={true}
                inputContainerStyle={{ width: '100%' }}
              />
              <Button text='Save' onPress={() => saveCaptionNew} />
            </View>
          </View>
        </Modal>
      </Portal>
    )
  }
  // initial modal for adding file name for document
  const newFileModal = () => {
    if (Platform.OS === 'web' && !documentModalVisible) {
      return null;
    }
    return (
      <Portal>
        <Modal
          animationType="fade"
          transparent={true}
          visible={documentModalVisible}
          style={Platform.OS === 'web' && CS.webModal}
          >
          <View style={styles.centeredView}>
            <View style={styles.modalView}>
              <TouchableOpacity activeOpacity={0.6} style={styles.captionModalClose} onPress={() => closeDocumentModal()}>
                <AntDesign name="closecircle" size={32} color={Colors.lightBlue} />
                <AntDesign name="closecircleo" size={32} color={Colors.blue3} style={{ position: 'absolute' }} />
              </TouchableOpacity>
              <Text style={[CS.smallText, CS.lightText, { marginBottom: 15 }]}>Name this file</Text>
              <TextInputContainer
                placeholder='Provide a name for this file'
                onChangeText={(t) => setFileName(t)}
                returnKeyType='done'
                onSubmitEditing={() => saveFileName}
                value={fileName}
                // style={styles.caption}
                autoCorrect={false}
                inputContainerStyle={{ width: '100%' }}
              />
              <Button text='Save' onPress={() => saveFileName} />
            </View>
          </View>
        </Modal>
      </Portal>
    )
  }
  // full screen modal for previewing items
  const previewItemModal = () => {
    if (Platform.OS === 'web' && !itemPreviewModalVisible) {
      return null;
    }
    return (
      <Portal>
        <Modal
          transparent={true}
          visible={itemPreviewModalVisible}
          style={Platform.OS === 'web' && CS.webModal}
          // presentationStyle='pageSheet'
        >
          <View style={styles.fullView}>
            {itemPreviewModalVisible &&
              <View style={[styles.captionOverlay, { paddingTop: insets.top ? insets.top : 10 }]} onLayout={(e) => { setCaptionOverlayHeight(e.nativeEvent.layout.height); console.log('onLayout() ', e.nativeEvent.layout.height) }}>
              <View style={[CS.rowContainer, styles.captionTextContainer]}>
                  {/* back arrow */}
                  <TouchableOpacity activeOpacity={0.6} onPress={() => setItemPreviewModalVisible(false)} style={styles.backCaptionIconContainer}>
                    <FontAwesome5 name="arrow-left" size={24} color={Colors.lightBlue} style={styles.backCaptionIcon} />
                  </TouchableOpacity>
                  {/* caption */}
                  <View style={styles.captionTextContainerInner}>
                  <Text style={[CS.mediumText, CS.lightText, CS.centerText, styles.captionText]}>{props.items[previewItemIndex].caption}</Text>
                    {(requiresApproval && !props.items[previewItemIndex].caption_accepted) &&
                      <TouchableOpacity activeOpacity={0.6} onPress={() => props.pendingApprovalAlert('caption')} style={{ marginLeft: 5 }}>
                        <AntDesign name="exclamationcircleo" size={24} color={Colors.blue} />
                        <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={styles.notAcceptedIcon} />
                      </TouchableOpacity>
                    }
                  </View>
                  {/* edit caption */}
                  {(props.captions && props.showAdd && (props.items[previewItemIndex].user_id == user.id)) &&
                  <TouchableOpacity activeOpacity={0.6} onPress={() => { startEditingCaption(); }}>
                      <Entypo name="edit" size={24} color={Colors.lightBlue} style={styles.editCaptionIcon} />
                  </TouchableOpacity>
                  }
                </View>
                <View style={[CS.rowContainer, styles.userDateCountContainer]}>
                  <View style={{ flex: 1 }}>
                    <Text style={[CS.miniText, CS.lightBlueText, styles.userText]}>{props.items[previewItemIndex].user}</Text>
                    <Text style={[CS.miniText, CS.lightBlueText]}>{props.items[previewItemIndex].date}</Text>
                  </View>
                  <Text style={[CS.miniText, CS.lightBlueText, styles.count]}>{previewItemIndex + 1} of {props.items.length}</Text>
                </View>
              </View>
            }
            <FlingGestureHandler
              direction={Directions.RIGHT}
              onHandlerStateChange={({ nativeEvent }) => {
                if (nativeEvent.state === State.END) {
                  console.log("I'm flinged rigth!: ", nativeEvent);
                  previousModalIndex();
                }
              }}>
              <FlingGestureHandler
                direction={Directions.LEFT}
                onHandlerStateChange={({ nativeEvent }) => {
                  if (nativeEvent.state === State.END) {
                    console.log("I'm flinged left!: ", nativeEvent);
                    nextModalIndex();
                  }
                }}>
                <View style={CS.flex}>
                  {(itemPreviewModalVisible && (props.items[previewItemIndex].type === 'image')) &&
                    <ScrollView contentContainerStyle={styles.imageContainer} maximumZoomScale='10' minimumZoomScale='1' bounces={false}>
                      {!props.items[previewItemIndex].existing &&
                        // <CachedImage source={{ uri: props.items[previewItemIndex].uri }} style={[styles.modalImg, previewImageStyle()]} />
                        <CachedImage source={{ uri: props.items[previewItemIndex].uri }} style={[styles.modalImg, previewImageStyle]} />
                      }
                      {props.items[previewItemIndex].existing &&
                        // <CachedImage source={{ uri: props.items[previewItemIndex].path }} style={[styles.modalImg, previewImageStyle()]} onLoadStart={() => setImageModalLoading(true)} onLoadEnd={() => setImageModalLoading(false)} />
                        <CachedImage source={{ uri: props.items[previewItemIndex].path }} style={[styles.modalImg, previewImageStyle]} onLoadStart={() => setImageModalLoading(true)} onLoadEnd={() => setImageModalLoading(false)} />
                      }
                    </ScrollView>
                  }
                  {(itemPreviewModalVisible && (props.items[previewItemIndex].existing) && (props.items[previewItemIndex].type === 'file')) &&
                    <View style={{ flex: 1 }}>
                      {Platform.OS === 'web' ?
                      <iframe
                        width='100%'
                        height='100%'
                        src={`${props.items[previewItemIndex].path}?jwt=${rtJWT}`}
                        frameborder='0'
                      ></iframe>
                      :
                      <PDFReader source={{ uri: props.items[previewItemIndex].path, headers: headers }} />
                      }
                      {/* <PDFReader source={{ uri: props.items[previewItemIndex].path, headers: headers }} /> */}
                    {/* <Text>PDFReader removed...</Text> */}
                    </View>
                  }
                  {/* not accepted */}
                  {(itemPreviewModalVisible && requiresApproval && !props.items[previewItemIndex].accepted) &&
                    <TouchableOpacity activeOpacity={0.6} onPress={() => props.pendingApprovalAlert(props.items[previewItemIndex].type)} style={styles.notAccepted}>
                      <AntDesign name="exclamationcircleo" size={24} color={Colors.blue} style={styles.notAcceptedIcon} />
                      <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={styles.notAcceptedIcon} />
                    </TouchableOpacity>
                  }
                </View>
              </FlingGestureHandler>
            </FlingGestureHandler>

            <TouchableOpacity activeOpacity={0.6} style={[styles.caretLeft, caretTop(), { marginTop: (captionOverlayHeight / 2) }]} onPress={() => previousModalIndex()}>
              <AntDesign name="caretleft" size={48} color={Colors.yellow} />
            </TouchableOpacity>
            <TouchableOpacity activeOpacity={0.6} style={[styles.caretRight, caretTop(), { marginTop: (captionOverlayHeight / 2) }]} onPress={() => nextModalIndex()}>
              <AntDesign name="caretright" size={48} color={Colors.yellow} />
            </TouchableOpacity>
            {/* <TouchableOpacity activeOpacity={0.6} style={[styles.imageModalClose, { bottom: insets.bottom }]} onPress={() => setItemPreviewModalVisible(false)}>
              <AntDesign name="closecircle" size={48} color={Colors.yellow} />
            </TouchableOpacity> */}
            {(itemPreviewModalVisible && props.items[previewItemIndex].existing && imageModalLoading && Platform.OS !== 'web') &&
              <ActivityIndicator size="large" color={Colors.lightBlue} style={styles.modalImgLoader} />
            }
            
            {editingCaption &&
              <View style={styles.editCaptionContainer}>
                <View style={styles.modalView}>
                  <TouchableOpacity activeOpacity={0.6} style={styles.captionModalClose} onPress={() => cancelEditingCaption()}>
                    <AntDesign name="closecircle" size={32} color={Colors.lightBlue2} />
                    <AntDesign name="closecircleo" size={32} color={Colors.blue3} style={{ position: 'absolute' }} />
                  </TouchableOpacity>
                  <Text style={[CS.smallText, CS.lightText, { marginBottom: 15 }]}>Add a caption for this photo</Text>
                  {(itemPreviewModalVisible && props.items[previewItemIndex].path) &&
                    // <Image source={{ uri: props.items[previewItemIndex].uri }} style={[styles.captionImg, { aspectRatio: props.items[previewItemIndex].width / props.items[previewItemIndex].height }]} />
                    <CachedImage source={{ uri: props.items[previewItemIndex].path }} style={[styles.captionImg, { aspectRatio: Images.project.main.width / Images.project.main.height }]} />
                  }
                  <TextInputContainer
                    placeholder='Provide a caption for this image'
                    onChangeText={(t) => changeCaption(t)}
                    returnKeyType='done'
                    onSubmitEditing={() => updateCaption}
                    value={props.items[previewItemIndex].caption}
                    // style={styles.caption}
                    autoCorrect={false}
                    spellCheck={true}
                    inputContainerStyle={{ width: '100%' }}
                  />
                  <Button text='Save' onPress={() => updateCaption} />
                </View>
              </View>
            }
            {editingExistingFileName &&
              <View style={styles.editCaptionContainer}>
                <View style={styles.modalView}>
                  <TouchableOpacity activeOpacity={0.6} style={styles.captionModalClose} onPress={() => cancelEditingExistingFileName()}>
                    <AntDesign name="closecircle" size={32} color={Colors.lightBlue} />
                    <AntDesign name="closecircleo" size={32} color={Colors.blue3} style={{ position: 'absolute' }} />
                  </TouchableOpacity>
                  <Text style={[CS.smallText, CS.lightText, { marginBottom: 15 }]}>Name this file</Text>
                  <TextInputContainer
                    placeholder='Provide a name for this file'
                    onChangeText={(t) => setFileName(t)}
                    returnKeyType='done'
                    onSubmitEditing={() => saveExistingFileName}
                    value={fileName}
                    // style={styles.caption}
                    autoCorrect={false}
                    inputContainerStyle={{ width: '100%' }}
                  />
                  <Button text='Save' onPress={() => saveExistingFileName} />
                </View>
              </View>
            }
          </View>
        </Modal>
      </Portal>
    )
  }

  // const previewImageStyle = () => {
  //   const ratio1 = props.items[previewItemIndex].existing ? Images.project.main.height / Images.project.main.width : props.items[previewItemIndex].height / props.items[previewItemIndex].width;
  //   const ratio2 = props.items[previewItemIndex].existing ? Images.project.main.width / Images.project.main.height : props.items[previewItemIndex].width / props.items[previewItemIndex].height;
  //   console.log('previewImageStyle', props.items[previewItemIndex].existing, Images.project.main.width, Images.project.main.height, props.items[previewItemIndex].width, props.items[previewItemIndex].height, ratio1, ratio2)
  //   if(Platform.OS === 'web'){
  //     const width = Dimensions.get('window').width;
  //     return {
  //       width: width,
  //       height: width * ratio1,
  //     }
  //   }
  //   return {
  //     aspectRatio: ratio2
  //   }
  // }

  const newImageStyle = () => {
    const ratio = captionImgResult.width / captionImgResult.height
    if(Platform.OS === 'web'){
      return {
        minHeight: 200,
        width: 200 * ratio,
      }
    }
    return {
      aspectRatio: ratio,
    }
  }

  return (
    <View style={styles.photos}>
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      {isScrollable ? 
        <ScrollView horizontal={true}>
          {itemsOutput()}
        </ScrollView>
        :
        itemsOutput()
      }
      {(props.showAdd || props.showAdd === undefined) &&
        // <TouchableOpacity style={[styles.newPhotoContainer, containerDimensions(horizontalCount, props.items.length)]} activeOpacity='0.6' onPress={() => addItem()}>
        <TouchableOpacity style={[styles.newPhotoContainer, containerStyle]} activeOpacity='0.6' onPress={() => addItem()}>
          <FontAwesome name="photo" size={60} color={Colors.yellowBrown} />
          <FontAwesome5 style={styles.photoPlus} name="plus" size={36} color={Colors.white} />
        </TouchableOpacity>
      }
      {(props.showAdd !== undefined && props.showAdd === false && props.items.length === 0) &&
        <View style={{padding: 5, borderWidth: 1, borderColor: Colors.lightBlue, borderRadius: 5, flex: 1, backgroundColor: Colors.textInputBackground}}>
          <Text style={[CS.smallText, CS.lightBlueText, CS.centerText, { flex: 1}]}>No images to display</Text>
        </View>
      }
      {newImageModal()}
      {newFileModal()}
      {props.items &&
        previewItemModal()
      }
    </View>
  )
}

export default PhotosDocumentsAddPreviewGrid;